var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('el-image-viewer',{attrs:{"z-index":_vm.zIndex,"initial-index":_vm.initialIndex,"on-close":_vm.onClose,"on-switch":_vm.onSwitch,"url-list":_vm.urlList}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }